import { render, staticRenderFns } from "./maintenanceBanner.vue?vue&type=template&id=19cb1871&scoped=true"
import script from "./maintenanceBanner.vue?vue&type=script&lang=js"
export * from "./maintenanceBanner.vue?vue&type=script&lang=js"
import style0 from "./maintenanceBanner.vue?vue&type=style&index=0&id=19cb1871&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19cb1871",
  null
  
)

export default component.exports